var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M14.668 14.668L20.0013 20.0013","stroke":"inherit","stroke-width":"2"}}),_vm._v(" "),_c('circle',{attrs:{"cx":"10.6667","cy":"10.6667","r":"5.91667","stroke":"inherit","stroke-width":"1.5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }